import React from 'react';
import './style.css';

import heroSection_one from '../../../Assets/products_landing/ControllerBannerimg1.png';
import heroSection_two from '../../../Assets/products_landing/Controllerbannerimg2.png';
import heroSection_three from '../../../Assets/products_landing/Controllerbanner3.png';

import bannerText from '../../../Assets/home/hero_section/banner_text.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Sliders from '../../../Molecules/Sliders';

const bannerSection = [
  {
    src: heroSection_one,
  },
  {
    src: heroSection_two,
  },
  {
    src: heroSection_three,
  },
];

export default function Banner() {
  return (
    <section className="banner flex bg-light-gradient pb-0 md:pb-28 lg:pb-40 pt-20 md:pt-28 lg:pt-40 my-10 xl:my-0">
      <div className="z-10 containers-min mx-auto sm:flex  md:flex-row flex-col sm:items-center ">
        <div className="md:w-6/12 h-fit flex justify-center items-start flex-col min-w-[300px] ">
          <h1 className="leading-tight !h3 font-gilroylight font-light">
            Supply Equipment Communication Controller (SECC)
          </h1>
          <h5 className="lg:mt-6 mt-4 font-poppins">
          Our SECC (Supply Equipment Communication Controller) is paving the way for faster, smarter EVSE development — helping you build custom EV chargers while significantly reducing your time-to-market
          </h5>
          {/* <h5 className="sm:mt-4 lg:mt-6 mt-5 lg:leading-9 leading-normal text-verde font-poppins">
          Reliable, Safe & Sustainable.
          </h5> */}
        </div>

        <div className="md:w-5/12 w-full p-4 md:mt-0 mt-10 mx-auto relative lg:min-h-[400px] min-h-[300px]">
          <Sliders data={bannerSection} classname="lg:min-h-[500px]" />
          <img
            loading="lazy"
            className="absolute top-1/2 -translate-y-2/3 xl:-right-20 -right-5 hidden md:block"
            src={bannerText}
            alt="Switch to EV"
          />
        </div>
      </div>
    </section>
  );
}
